<template>
  <el-col :span="normalizedSpan">
    <el-form-item :prop="name" :label="label" :label-width="labelWidth" :required="required" :rules="normalizedRules">
      <OSingleSelect v-model="model" :placeholder="placeholder" :disabled="normalizedDisabled" :code="code"
        :clearable="clearable" :filterable="filterable" @change="(attrs.onChange)"></OSingleSelect>
    </el-form-item>
  </el-col>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
import { ElCol, ElFormItem } from 'element-plus'
import type { FormSingleSelectProps } from './SingleSelect'
import OSingleSelect from '../../Input/SingleSelect/SingleSelect.vue'
import { useFormItemSpan, useFormItemRules, useFormItemModel, useFormItemDisabled } from '../hooks'

defineOptions({ name: 'OFormSingleselect', inheritAttrs: false })
const attrs = useAttrs()

const { name, label, labelWidth, required, placeholder, code, clearable, filterable } = defineProps<FormSingleSelectProps>()
const normalizedSpan = useFormItemSpan()
const normalizedRules = useFormItemRules()
const normalizedDisabled = useFormItemDisabled()
const model = useFormItemModel()
</script>
